import { Theme } from '@/styles/theme'

export const RED = 'red'
export const GRAY = 'gray'
export const WHITE = 'white'

export const hexRed = '#F54337'
export const hexGray = '#A4A3A3'
export const hexBlack = '#272525'

export const hexBorderRed = '#f54337'
export const hexBorderGray = '#ececec'
export const hexBorderWhite = '#d0d0d0'

export const hexBackgroundRed = '#f7eaea'
export const hexBackgroundGray = '#ececec'
export const hexBackgroundWhite = ({ theme }: { theme: Theme }) =>
  `${theme.ds.ColorBaseWhite}`

export const LABELCOLORS = {
  red: `
    color: ${hexRed};
  `,
  gray: `
    color: ${hexGray};
  `,
  white: `
    color: ${hexBackgroundWhite};
  `,
}

export const TEXTAREASCHEMAS = {
  red: `
      color: ${hexBlack};
      border-color: ${hexBorderRed};
      background-color: ${hexBackgroundRed};
    `,
  gray: `
      color: ${hexBlack};
      border-color: ${hexBorderGray};
      background-color: ${hexBackgroundGray};
    `,
  white: `
      color: ${hexBlack};
      border-color: ${hexBorderWhite};
      background-color: ${hexBackgroundWhite};
    `,
}
